<ng-container *transloco="let t">
  <div class="flex flex-col -m-6">
    <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ 'services.dialog.cloneService.title' | transloco }}</div>
    </div>

    <div class="w-full flex flex-col p-8">
      <mat-form-field class="fuse-mat-no-subscript p-2 mt-4">
        <input matInput [formControl]="control">
      </mat-form-field>
      @if (control.touched && control.errors?.required) {
        <mat-error class="ml-3">
          {{ 'errorRequiredField' | transloco }}
        </mat-error>
      }
      <div class="flex flex-row justify-end pt-4">
        <button mat-flat-button class="mr-8" color="warn" (click)="saveName('cancel', $event)">{{ 'cancel' | transloco }}</button>
        <button mat-flat-button class="mr-8" color="primary" (click)="saveName('save')">{{ 'clone' | transloco }}</button>
      </div>
    </div>

  </div>
</ng-container>
